module.exports = __webpack_public_path__ + "img/vivreensemble.05921f96.png";